// Registration form utilities & validation helpers.
// Extracted from Registration.jsx to reduce cyclomatic complexity.

const PHONE_RE = /^\+?[0-9\s-]{7,15}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateRegistrationForm(form) {
  if (!form || !form.name || !form.name.trim()) {
    return 'Please enter your name';
  }
  if (!PHONE_RE.test((form.phone || '').trim())) {
    return 'Please enter a valid phone number';
  }
  if (form.email && !EMAIL_RE.test(form.email)) {
    return 'Please enter a valid email';
  }
  if (!form.student_class) {
    return 'Please select a class';
  }
  return '';
}

export const EMPTY_FORM = Object.freeze({
  name: '',
  phone: '',
  email: '',
  student_class: '',
  subject: '',
});
